<template>
  <div>
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="row mt-1" v-if="user.usuario_nome != ''">
      <div class="col-12 font-30">
        Olá, {{ $store.state.user.usuario_nome }}!
      </div>
    </div>

    <div class="row mt-4">
      <div class="centered my-custom-column">
        <div class="flux-slider-shell" ref="sliderShell">
          <vue-flux
            :options="fluxOptions"
            :images="fluxImages"
            :transitions="fluxTransitions"
            ref="slider"
            class="flux-slider"
          >
          </vue-flux>
        </div>

        <div
          v-if="sliderReady"
          class="slider-dots"
          aria-label="Indicador de slides"
        >
          <button
            v-for="(img, index) in fluxImages"
            :key="`dot-${index}`"
            type="button"
            class="slider-dot"
            :class="{ active: currentSlideIndex === index }"
            :aria-label="`Ir para slide ${index + 1}`"
            @click="goToSlide(index)"
          ></button>
        </div>

        <div class="row mt-2" v-if="statusUltimaOcorrencia">
          <div class="menu-list">
            <div class="card card-style rounded-m p-3 py-2 mb-3 pisca">
              <router-link
                :to="'/visualizar-atendimento/' + ocorrencias[0].ocorrencia_id"
              >
                <i class="gradient-yellow bi bi-play-circle-fill"></i>
                <span class="text_button"
                  ><strong>Atendimento em Andamento</strong>
                  <span
                    class="badge badge-pill badge-danger"
                    v-if="ocorrencias[0].qtd_messages > 0"
                    >{{ ocorrencias[0].qtd_messages }} nova{{
                      ocorrencias[0].qtd_messages > 1 ? "s" : ""
                    }}</span
                  ></span
                >
                <i class="bi bi-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-else>
          <div class="menu-list">
            <div class="card card-style rounded-m p-3 py-2 mb-3">
              <router-link to="/solicitar-atendimento">
                <i
                  class="gradient-green bi bi-telephone-plus-fill mt-1 ml-1"
                ></i>
                <span class="text_button"
                  ><strong>Chamar SAMU Capital - RJ</strong></span
                >
                <i class="bi bi-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="menu-list">
            <div class="card card-style rounded-m p-3 py-2 mb-3">
              <router-link to="/ultimas_solicitacoes">
                <i class="gradient-red bi bi-clock-history mt-1 ml-1"></i>
                <span class="text_button"
                  ><strong>Meus Últimos Atendimentos</strong></span
                >
                <i class="bi bi-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <!-- <div class="row-mt-3">
          <img
            src="@/assets/images/Captura de tela de 2024-11-05 15-08-19.png"
            alt="Additional Image"
            class="carousel-image"
            style="margin-bottom: 120px"
          />
        </div> -->
        <footer class="home-footer">
          <img
            src="@/assets/images/logo-samu-192.png"
            alt="Logo SAMU"
            class="home-footer-logo"
          />
        </footer>
      </div>
    </div>
  </div>
  <!-- <div v-else class="error-message">
    <div class="error-container">
      <b-icon
        icon="exclamation-circle"
        variant="danger"
        class="error-icon"
      ></b-icon>
      <div class="error-text">
        Infelizmente não poderemos seguir com a sua solicitação. Este aplicativo
        atende apenas o SAMU- Capital do Rio de Janeiro. Aconselhamos que ligue
        para o 192 da sua cidade local.
      </div>
    </div>
  </div> -->
</template>

<script>
import Loading from "vue-loading-overlay";
import { VueFlux, Transitions } from "vue-flux";
export default {
  data() {
    return {
      user: {
        usuario_nome: "  "
      },
      locationError: false,
      fluxOptions: {
        autoplay: true,
        delay: 4500,
        infinite: true,
        enableGestures: false
      },
      fluxImages: [
        require("@/assets/images/carrossel/15.png"),
        require("@/assets/images/carrossel/1.png"),
        require("@/assets/images/carrossel/2.png"),
        require("@/assets/images/carrossel/3.png"),
        require("@/assets/images/carrossel/4.png"),
        require("@/assets/images/carrossel/5.png"),
        require("@/assets/images/carrossel/6.png"),
        require("@/assets/images/carrossel/7.png"),
        require("@/assets/images/carrossel/8.png"),
        require("@/assets/images/carrossel/9.png"),
        require("@/assets/images/carrossel/10.png"),
        require("@/assets/images/carrossel/11.png")
      ],
      fluxTransitions: {
        transitionBook: Transitions.transitionSlide
      },
      isLoading: false,
      loadingColor: "#5D9CEC",
      /* ocorrencias: {
        latitude: 0,
        longitude: 0,
        queixa_principal: "",
        ip: "",
        paciente_id: 0,
        usuario_solicitante_id: 0,
        paciente: {
          nome_paciente: '',
        },
      }, */
      ocorrencias: [],
      statusUltimaOcorrencia: 0,
      usr_id: {
        usuario_id: ""
      },
      usuario_nome: "",
      sliderReady: false,
      touchStartX: 0,
      touchCurrentX: 0,
      touchStartY: 0,
      touchCurrentY: 0,
      touchThreshold: 28,
      autoplayResumeTimer: null,
      currentSlideIndex: 0,
      slideSyncIntervalId: null
    };
  },
  computed: {
    exibirStatus() {
      return this.ocorrencias.map(ocorrencia => {
        if (ocorrencia.status === 0) {
          return "Solicitado";
        } else if (ocorrencia.status === 1) {
          return "Em Andamento";
        } else if (ocorrencia.status === 2) {
          return "Finalizado";
        } else if (ocorrencia.status === 3) {
          return "Cancelado";
        } else {
          return ocorrencia.status.toString();
        }
      });
    }
  },
  methods: {
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
    view(id) {
      const self = this;
      /* self.isLoading = true */
      this.$router.push("/visualizar-atendimento/" + id);
      /* this.$router.push({
        path: this.$router + "/editar-paciente/" + id,
      }); */
    },
    getOcorrencias(id) {
      const self = this;
      self.isLoading = true;

      this.usr_id.usuario_id = Number(id);
      const api =
        self.$store.state.api + "usuario-ocorrencias?orderByDesc=createdAt";

      axios
        .post(api, this.usr_id)
        .then(response => {
          self.user = self.$store.state.user;
          self.ocorrencias = response.data;
          if (
            self.ocorrencias.length > 0 &&
            self.ocorrencias[0].data_fim_atendimento == null &&
            self.ocorrencias[0].data_cancelamento == null
          ) {
            self.statusUltimaOcorrencia = true;
          }
          self.isLoading = false;

          // var intervalSla = setInterval(() => {
          //   clearInterval(intervalSla);
          //   self.getOcorrencias(id);
          // }, 4000);
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
    checkLocation() {
      if (!navigator.geolocation) {
        // Geolocalização não suportada
        this.locationError = true; // Ativar a mensagem de erro
        this.errorMessage = "Seu navegador não suporta geolocalização.";
      } else {
        navigator.geolocation.getCurrentPosition(
          position => {
            // Localização bem-sucedida
            console.log("Localização obtida:", position);
            this.locationError = false; // Resetar o erro se a localização foi obtida
          },
          error => {
            // Erro ao obter a localização
            console.error("Erro ao obter a localização:", error);
            this.locationError = true; // Ativar a mensagem de erro

            swal(
              "Ops!",
              "Não conseguimos recuperar sua localização com base no GPS, você precisará informar o endereço para prosseguir com sua solicitação.",
              "info"
            );

            // Verificar o código de erro
            if (error.code === error.PERMISSION_DENIED) {
              this.errorMessage =
                "Acesso à geolocalização foi negado. Por favor, ative a localização nas configurações do seu navegador.";
            } else if (error.code === error.POSITION_UNAVAILABLE) {
              this.errorMessage =
                "Localização não disponível. Tente novamente mais tarde.";
            } else {
              this.errorMessage =
                "Erro ao obter a localização. Tente novamente.";
            }
          }
        );
      }
    },
    onSliderTouchStart(event) {
      if (!event.touches || event.touches.length !== 1) {
        return;
      }

      this.touchStartX = event.touches[0].clientX;
      this.touchCurrentX = this.touchStartX;
      this.touchStartY = event.touches[0].clientY;
      this.touchCurrentY = this.touchStartY;
    },
    onSliderTouchMove(event) {
      if (!event.touches || event.touches.length !== 1) {
        return;
      }

      this.touchCurrentX = event.touches[0].clientX;
      this.touchCurrentY = event.touches[0].clientY;

      const deltaX = this.touchCurrentX - this.touchStartX;
      const deltaY = this.touchCurrentY - this.touchStartY;

      if (Math.abs(deltaX) > Math.abs(deltaY) && event.cancelable) {
        event.preventDefault();
      }
    },
    onSliderTouchEnd(event) {
      if (event && event.changedTouches && event.changedTouches.length === 1) {
        this.touchCurrentX = event.changedTouches[0].clientX;
        this.touchCurrentY = event.changedTouches[0].clientY;
      }

      const deltaX = this.touchCurrentX - this.touchStartX;
      const deltaY = this.touchCurrentY - this.touchStartY;

      this.touchStartX = 0;
      this.touchCurrentX = 0;
      this.touchStartY = 0;
      this.touchCurrentY = 0;

      if (
        Math.abs(deltaX) < this.touchThreshold ||
        Math.abs(deltaX) <= Math.abs(deltaY)
      ) {
        return;
      }

      this.navigateSlider(deltaX < 0 ? "next" : "previous");
    },
    navigateSlider(direction) {
      const slider = this.$refs.slider;

      if (!slider) {
        return;
      }

      if (typeof slider.showImage === "function") {
        slider.showImage(direction === "next" ? "next" : "prev");
      } else if (typeof slider.show === "function") {
        slider.show(direction === "next" ? "next" : "previous");
      } else if (direction === "next" && typeof slider.next === "function") {
        slider.next();
      } else if (
        direction === "previous" &&
        typeof slider.prev === "function"
      ) {
        slider.prev();
      }

      this.resumeAutoplay();
      this.syncCurrentSlideIndex();
    },
    goToSlide(index) {
      const slider = this.$refs.slider;

      if (!slider) {
        return;
      }

      if (typeof slider.showImage === "function") {
        slider.showImage(index);
      } else if (typeof slider.show === "function") {
        slider.show(index);
      }

      this.currentSlideIndex = index;
      this.resumeAutoplay();
    },
    syncCurrentSlideIndex() {
      const slider = this.$refs.slider;

      if (!slider || typeof slider.currentImage !== "function") {
        return;
      }

      const currentImage = slider.currentImage();
      if (!currentImage || typeof currentImage.index !== "number") {
        return;
      }

      this.currentSlideIndex = currentImage.index;
    },
    resumeAutoplay() {
      if (this.autoplayResumeTimer) {
        clearTimeout(this.autoplayResumeTimer);
      }

      this.autoplayResumeTimer = setTimeout(() => {
        const slider = this.$refs.slider;

        if (slider && typeof slider.start === "function") {
          slider.start();
        } else if (slider && typeof slider.play === "function") {
          slider.play();
        }
      }, 350);
    }
  },
  components: { Loading, VueFlux },
  props: {},
  mounted() {
    const self = this;

    self.isLoading = false;

    this.checkLocation();

    var id = localStorage.getItem("usuario_id");

    if (typeof self.getOcorrencias === "function") {
      self.getOcorrencias(id);
    }

    this.authenticated = this.$store.getters.authenticated;

    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    $("body").removeClass("top-navigation");
    $("body").removeClass("custom-login");

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    this.$nextTick(() => {
      this.sliderReady = true;
      this.syncCurrentSlideIndex();
      this.slideSyncIntervalId = setInterval(this.syncCurrentSlideIndex, 250);

      const shell = this.$refs.sliderShell;
      if (shell) {
        shell.addEventListener("touchstart", this.onSliderTouchStart, {
          passive: true
        });
        shell.addEventListener("touchmove", this.onSliderTouchMove, {
          passive: false
        });
        shell.addEventListener("touchend", this.onSliderTouchEnd, {
          passive: true
        });
        shell.addEventListener("touchcancel", this.onSliderTouchEnd, {
          passive: true
        });
      }
    });

    /*  var usr_nome = localStorage.getItem('usuario_nome');
    this.usuario_nome = usr_nome; */
  },
  beforeDestroy() {
    if (this.autoplayResumeTimer) {
      clearTimeout(this.autoplayResumeTimer);
    }

    if (this.slideSyncIntervalId) {
      clearInterval(this.slideSyncIntervalId);
    }

    const shell = this.$refs.sliderShell;
    if (shell) {
      shell.removeEventListener("touchstart", this.onSliderTouchStart);
      shell.removeEventListener("touchmove", this.onSliderTouchMove);
      shell.removeEventListener("touchend", this.onSliderTouchEnd);
      shell.removeEventListener("touchcancel", this.onSliderTouchEnd);
    }
  }
};
</script>
<style scoped>
/* CARROSSEL */
.flux-slider-shell {
  width: 100%;
  touch-action: pan-y;
}

.flux-slider {
  width: 100%;
  height: auto;
  max-height: 260px;
  min-height: 255px;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
}

.flux-slider img,
.flux-slider .flux-slide,
.flux-slider .flux-slide-image,
.flux-slider .flux-slider-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  object-position: center !important;
}

.flux-slider .flux-slide {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 180px !important;
  max-height: 280px !important;
  overflow: hidden !important;
}

.flux-slider .flux-slide img {
  width: 100% !important;
  height: auto !important;
  max-height: 280px !important;
  object-fit: contain !important;
  object-position: center !important;
}

@media (max-width: 768px) {
  .flux-slider {
    max-height: 220px !important;
  }

  .flux-slider .flux-slide {
    max-height: 220px !important;
  }

  .flux-slider .flux-slide img {
    max-height: 220px !important;
  }
}

.slider-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;
  margin: 8px 0 12px;
  padding: 0;
}

.slider-dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  border: 1px solid #8f96a0;
  background-color: #ffffff;
  box-shadow: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
}

.slider-dot.active {
  background-color: #747d89;
  border-color: #747d89;
}

.slider-dot:hover {
  transform: scale(1.08);
}

.carousel-image {
  display: block;
  margin-top: 40px;
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 16px;
}

/* SAUDAÇÃO */
.row.mt-1 {
  margin-bottom: 15px;
}

.row.mt-1 .font-30 {
  font-size: 22px !important;
  font-weight: 700;
  background: linear-gradient(135deg, #db6940 0%, #d6582c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
  line-height: 1.3;
  margin: 0;
}

/* MENU PRINCIPAL */
.menu-list {
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}

.card-style {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100px;
  padding: 0 !important;
}

.card-style:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.text_button {
  font-size: 17px !important;
}

.card-style a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: #1f2937;
  font-weight: 600;
  font-size: 19px;
  gap: 16px;
  height: 100%;
  padding: 0 20px;
}

.card-style i:first-child {
  flex-shrink: 0;
}

.card-style span:not(.badge) {
  flex: 1;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 19px;
}

.card-style i:last-child {
  font-size: 20px;
  opacity: 0.6;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.card-style:hover i:last-child {
  opacity: 1;
  transform: translateX(4px);
}

/* ÍCONES COM GRADIENTES */
.gradient-yellow {
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
  color: white !important;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px !important;
  flex-shrink: 0;
}

.gradient-green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white !important;
  border-radius: 50%;
  width: 74px;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px !important;
  flex-shrink: 0;
}

.gradient-red {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white !important;
  border-radius: 50%;
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px !important;
  flex-shrink: 0;
}

.shadow-bg {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* PISCA - ATENDIMENTO EM ANDAMENTO */
.pisca {
  animation: animate 2.5s linear infinite;
  background: linear-gradient(
    135deg,
    #fff 0%,
    #fef3c7 50%,
    #fff 100%
  ) !important;
}

@keyframes animate {
  0% {
    background: linear-gradient(135deg, #fff 0%, #fef3c7 50%, #fff 100%);
  }
  50% {
    background: linear-gradient(135deg, #fef3c7 0%, #fcd34d 50%, #fef3c7 100%);
  }
  100% {
    background: linear-gradient(135deg, #fff 0%, #fef3c7 50%, #fff 100%);
  }
}

/* BADGE */
.badge-danger {
  color: #fff !important;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  font-size: 11px !important;
  padding: 4px 8px !important;
  margin-left: 8px;
}

.badge-pill {
  padding-right: 0.6em !important;
  padding-left: 0.6em !important;
  border-radius: 10rem !important;
}

.badge {
  display: inline-block !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  vertical-align: baseline !important;
}

/* LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* INPUTS */
.custom-input {
  border-radius: 8px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.custom-input:focus {
  border-color: #1548a6;
  box-shadow: 0 0 0 3px rgba(21, 72, 166, 0.1);
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .row.mt-3 .font-30 {
    font-size: 22px !important;
  }

  .flux-slider {
    height: 210px;
  }

  .card-style a {
    font-size: 14px;
  }

  .gradient-yellow,
  .gradient-green,
  .gradient-red {
    width: 52px;
    height: 52px;
    font-size: 24px !important;
  }
}

@media (max-width: 480px) {
  .row.mt-3 .font-30 {
    font-size: 22px;
    margin-bottom: 15px;
  }

  .flux-slider {
    height: 180px;
  }

  .card-style {
    padding: 14px 16px !important;
  }

  .card-style a {
    font-size: 15px;
  }

  .gradient-yellow,
  .gradient-green,
  .gradient-red {
    width: 48px;
    height: 48px;
    font-size: 22px !important;
  }
}

/* RESETS E AJUSTES */
.my-custom-column {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}

.botao-cadastrar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.btn {
  width: 100% !important;
  background: linear-gradient(135deg, #1548a6 0%, #2563eb 100%) !important;
  border: none !important;
  border-radius: 10px !important;
  margin: 0px 15px 18px -29px;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 12px rgba(21, 72, 166, 0.3) !important;
}

.btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(21, 72, 166, 0.4) !important;
}

h5 {
  font-weight: normal;
}

.error-message {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 1rem;
  border-radius: 8px;
}

.error-container {
  display: flex;
  align-items: center;
}

.error-icon {
  margin-right: 1rem;
}

.home-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -10px;
  padding: 0 0 20px;
}

.home-footer-logo {
  width: 300px;
  height: auto;
  opacity: 0.95;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue